import { AnimatedSprite, Texture } from 'pixi.js';

export default class SpriteAnimation {
  animatedSprite: AnimatedSprite;
  constructor({ frames }: { frames: Texture[] }) {
    this.animatedSprite = new AnimatedSprite(frames);
  }
  play() {
    this.animatedSprite.play();
  }
  stop() {
    this.animatedSprite.stop();
  }
  gotoAndPlay(frameNumber: number) {
    this.animatedSprite.gotoAndPlay(frameNumber);
  }
  gotoAndStop(frameNumber: number) {
    this.animatedSprite.gotoAndStop(frameNumber);
  }
  set speed(val: number) {
    this.animatedSprite.animationSpeed = val;
  }
  get speed() {
    return this.animatedSprite.animationSpeed;
  }
}
